import Swiper from "swiper"

export function initClientSaySwaper() {
    let swiper = new Swiper(".client-say-swiper", {
       slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        grabCursor: true,
        autoplay: {
            delay: 3000
        },
        pagination: {
            el: ".client-say-swiper-pagination",
            clickable: true,
        },
          breakpoints: {
            700: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1100: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        }
    });
}